import { Flex, Stack, type StackProps } from '@chakra-ui/react';
import { SidebarNavItems } from './sidebarNavItems';
import { useNavItemStore } from '@invara-dev/react-base';

interface SidebarProps extends StackProps {
  showAdminNav: boolean;
}

export const Sidebar = (props: SidebarProps) => {
  const { ...rest } = props;
  const items = useNavItemStore((state) => state.getDefault());

  return (
    <Stack p={'4'} bg='bg.panel' {...rest}>
      <Stack gap='8' width={'224px'}>
        <SidebarNavItems items={items} />
      </Stack>
      <Flex direction={'column'}></Flex>
    </Stack>
  );
};
